"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var TemplateTiles = (function () {
    function TemplateTiles(createUi, getTemplateTile, selectTemplate, results, templateState) {
        var selectTemplateTile = function (result, selectedTileId, message) {
            templateTiles.forEach(function (templateTile) {
                templateTile.active = selectedTileId === templateTile.id;
                templateTile.templateUiList.forEach(function (templateUi) {
                    templateUi.active = templateTile.active && result.projectId === templateUi.projectId;
                });
            });
            selectTemplate(message || "template group selected", result, selectedTileId);
        };
        var tileNames = lodash_1.default.sortBy(lodash_1.default.keys(results));
        var templateTiles = tileNames.map(function (tileName) {
            var tileId = lodash_1.default.kebabCase(tileName);
            var templateList = results[tileName];
            var active = tileId === templateState.tile;
            var activeTemplate = templateState.projectId ? templateState.projectId : undefined;
            return getTemplateTile({
                name: tileName,
                id: tileId,
                theme: templateState.useCase,
                templateList: templateList,
                active: active,
                activeTemplate: activeTemplate,
                selectTemplate: selectTemplateTile,
            });
        });
        this._ui = createUi(require("./TemplateTiles.html"), {
            templateTiles: templateTiles,
        });
        var getTile = function (tileId) {
            if (!tileId) {
                return null;
            }
            return templateTiles.find(function (templateTile) {
                if (templateTile.id == tileId) {
                    return true;
                }
            });
        };
        if (templateTiles.length > 0) {
            var tile = getTile(templateState.tile);
            if (!tile) {
                templateTiles[0].selectFirstTemplate();
            }
            else {
                tile.selectFirstTemplate();
            }
        }
    }
    Object.defineProperty(TemplateTiles.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return TemplateTiles;
}());
exports.default = TemplateTiles;
